// Let's try to use this function to fetch data from Contentful, instead of repeating the fetch logic in every app
// Does not handle errors so you should wrap this in a try/catch block and handle Sentry logging or similar
export const fetchFromContentful = async <T>(
  url: string,
  apiKey: string,
  graphql: { query: string; variables?: Record<string, string | number | boolean> },
) => {
  const response = await fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      authorization: `Bearer ${apiKey}`,
    },
    method: 'POST',
    body: JSON.stringify(graphql),
    signal: AbortSignal.timeout(10000),
  });

  return (await response.json()).data as T;
};
